import { Injectable } from '@angular/core';
import { ZOOM_SCALES } from './constants';

@Injectable({ providedIn: 'root' })
export class MapResolutionZoomService {
  extractResolutionInMeters(source: any): number | null {
    const candidates = [
      typeof source === 'string' ? source : undefined,
      source?.value,
      source?.providerResolution,
      source?.selectedResolution,
      source?.selectedResolutionValue,
      source?.resolution,
      source?.resolution_tooltip,
      source?.resolutionTooltip,
      source?.name,
      source?.sensor,
    ]
      .filter((value) => value !== undefined && value !== null)
      .map((value) => String(value));

    for (const candidate of candidates) {
      const explicitUnitMatch = candidate.match(/(\d+(?:\.\d+)?)\s*(cm|m)\b/i);
      if (explicitUnitMatch) {
        const value = Number(explicitUnitMatch[1]);
        const unit = explicitUnitMatch[2].toLowerCase();
        return unit === 'cm' ? value / 100 : value;
      }

      const colonResolutionMatch = candidate.match(
        /(?:resolution|pan-sharpened|hd|high definition)[^:]*:\s*(\d+(?:\.\d+)?)/i
      );
      if (colonResolutionMatch) {
        return Number(colonResolutionMatch[1]);
      }
    }

    return null;
  }

  calculateZoomFromResolution(source?: any, defaultZoom: number = 18): number {
    const sources = Array.isArray(source) ? source : [source];
    let resolution: number | null = null;

    for (const currentSource of sources) {
      resolution = this.extractResolutionInMeters(currentSource);
      if (resolution) {
        break;
      }
    }

    if (!resolution || resolution <= 0) {
      return defaultZoom;
    }

    const webMercatorResolutionAtZoomZero = Number(ZOOM_SCALES?.[0]) || 156543;
    const zoomLevel = Math.ceil(
      Math.log2(webMercatorResolutionAtZoomZero / resolution)
    );

    return Math.min(Math.max(zoomLevel, 0), 23);
  }

}
